/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamShapingGroupDto } from './BeamShapingGroupDto';
import {
    BeamShapingGroupDtoFromJSON,
    BeamShapingGroupDtoFromJSONTyped,
    BeamShapingGroupDtoToJSON,
} from './BeamShapingGroupDto';

/**
 * 
 * @export
 * @interface BeamShapingContainerDto
 */
export interface BeamShapingContainerDto {
    /**
     * 
     * @type {BeamShapingGroupDto}
     * @memberof BeamShapingContainerDto
     */
    availableBeamShaping: BeamShapingGroupDto;
    /**
     * 
     * @type {Array<BeamShapingGroupDto>}
     * @memberof BeamShapingContainerDto
     */
    selectedBeamShapings: Array<BeamShapingGroupDto>;
    /**
     * 
     * @type {boolean}
     * @memberof BeamShapingContainerDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BeamShapingContainerDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingContainerDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingContainerDto
     */
    $type?: BeamShapingContainerDtoTypeEnum;
}


/**
 * @export
 */
export const BeamShapingContainerDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersBeamShapingContainerDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingContainerDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamShapingContainerDtoTypeEnum = typeof BeamShapingContainerDtoTypeEnum[keyof typeof BeamShapingContainerDtoTypeEnum];



/**
 * Check if a given object implements the BeamShapingContainerDto interface.
 */
export function instanceOfBeamShapingContainerDto(value?: unknown): value is BeamShapingContainerDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamShapingContainerDtoTypeEnum)[0];
}

export function BeamShapingContainerDtoFromJSON(json: any): BeamShapingContainerDto {
    return BeamShapingContainerDtoFromJSONTyped(json, false);
}

export function BeamShapingContainerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamShapingContainerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'availableBeamShaping': BeamShapingGroupDtoFromJSON(json['availableBeamShaping']),
        'selectedBeamShapings': ((json['selectedBeamShapings'] as Array<any>).map(BeamShapingGroupDtoFromJSON)),
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'name': json['name'] == null ? undefined : json['name'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamShapingContainerDtoToJSON(value?: BeamShapingContainerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'availableBeamShaping': BeamShapingGroupDtoToJSON(value['availableBeamShaping']),
        'selectedBeamShapings': ((value['selectedBeamShapings'] as Array<any>).map(BeamShapingGroupDtoToJSON)),
        'isRequired': value['isRequired'],
        'isEnabled': value['isEnabled'],
        'name': value['name'],
        '$type': value['$type'],
    });
}

